import React from 'react';
import Icon from '../../common/styles/Icon';

interface Props {
  onClick?: () => void;
}

const AccountIcon = (props: Props) => (
  <Icon size={24} iconName="user-off" onClick={props.onClick} leftOfText />
);

export default AccountIcon;
